<template>
  <h1 class="text-lg">Halaman tidak ditemukan.</h1>
  <p class="text-sm text-gray-500">
    Kemungkinan halaman telah dihapus atau Anda salah menulis URL.
    <router-link to="/admin/home" class="block mt-2 text-blue-500">
      Kembali ke Beranda
    </router-link>
  </p>
</template>
